module.exports = __webpack_public_path__ + "img/实验室净化2.7b56211e.jpg";